import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Resume = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h5">{t('schedule_rules.title')}</Typography>
        </Box>
    );
};

export { Resume };
